import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal, Button } from "react-bootstrap";
import Select from "react-select";
import Swal from "sweetalert2";
import { useForm, Controller, useFieldArray } from "react-hook-form";

export default function UpdatePhieuXuatKho({ item, icons, icon, data: DATA }) {
  const { lang, proxy, functions } = useSelector((state) => state);
  const [showModal, setShowModal] = useState(false);
  const [data, setData] = useState([]);
  const token = localStorage.getItem("_token");
  const [search, setSearch] = useState();
  const [loading, setLoading] = useState(true);
  const { control, handleSubmit, register, reset, setValue, getValues } =
    useForm({
      defaultValues: {
        dataLogsPXk: data?.[0]?.dataLogsPXk || [],
        ghichu: "",
      },
    });

  const { fields, remove, append } = useFieldArray({
    control,
    name: "dataLogsPXk",
  });

  useEffect(() => {
    const dataLogsPXk = data?.[0]?.dataLogsPXk;
    const sanpham = data?.[0]?.sanpham;

    if (dataLogsPXk && dataLogsPXk.length) {
      const mapped = dataLogsPXk.map((item, index) => {
        return {
          ...item,
          tensanpham: item?.tensanpham ?? sanpham?.[index]?.["10TSP"],
        };
      });
      reset({
        dataLogsPXk: mapped,
        ghichu: "",
      });
    }
  }, [data, reset]);

  useEffect(() => {
    if (!search) return;
    fetch(proxy() + `/api/SyncERP/Search/PhieuXuatKho`, {
      method: "POST",
      headers: {
        Authorization: token,
        "content-type": "application/json",
      },
      body: JSON.stringify(search),
    })
      .then((res) => res.json())
      .then((res) => {
        const { result, total } = res;
        setData(result);
      })
      .finally(() => setLoading(false));
  }, [search]);

  const handleModalShow = () => {
    setShowModal(true);
    setSearch((prev) => ({
      ...prev,
      ["maphieuxuatkho"]: DATA?.["maPhieuXuatKhoERP"],
    }));
  };

  const handleModalClose = () => setShowModal(false);

  //   const handleCancelVote = () => {
  //     Swal.fire({
  //       title: "Đang hủy phiếu...",
  //       allowEscapeKey: false,
  //       allowOutsideClick: false,
  //       didOpen: () => {
  //         Swal.showLoading();
  //       },
  //     });

  //     const payload = {
  //       ...data?.[0],
  //       data: data?.[0]?.dataLogsPXk,
  //       action: "cancel",
  //     };

  //     try {
  //       fetch(`https://testhub.pvfcco.com.vn/ebs/rfid/postdmpxk`, {
  //         method: "POST",
  //         headers: {
  //           Authorization: token,
  //           "content-type": "application/json",
  //         },
  //         body: JSON.stringify({
  //           ...payload,
  //         }),
  //       })
  //         .then((res) => res.json())
  //         .then((res) => {
  //           const { result, total, success } = res;
  //           // setData(result);
  //           if (!success) {
  //             Swal.fire({
  //               icon: "error",
  //               title: lang["error"],
  //               text: "",
  //               confirmButtonText: lang["ok"],
  //               allowOutsideClick: false,
  //             });
  //           }
  //         })
  //         .finally(() => {
  //           setLoading(false);
  //           Swal.close();
  //         });
  //     } catch (e) {
  //       Swal.fire({
  //         icon: "error",
  //         title: lang["error"],
  //         text: e,
  //         confirmButtonText: lang["ok"],
  //         allowOutsideClick: false,
  //       });
  //     }
  //   };
  const onSubmit = (d) => {
    const mappedData = {
      data: {
        ...data[0],
        data: d?.dataLogsPXk,
        actionLogsPXk: "cancel",
        action: "cancel",
      },
      TenTaiKhoanThietBi: data?.[0]?.tenTaiKhoanThietBi,
      TaiKhoanThietBi: data?.[0]?.tenTaiKhoanThietBi,
    };

    Swal.fire({
      title: "Đang hủy phiếu...",
      allowEscapeKey: false,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      fetch(proxy() + `/api/SyncERP/PhieuXuatKho`, {
        method: "POST",
        headers: {
          Authorization: token,
          "content-type": "application/json",
        },
        body: JSON.stringify(mappedData),
      })
        .then((res) => res.json())
        .then((res) => {
          const { result, total, success, o_message, o_status } = res;
          // setData(result);
          if (o_status !== "200") {
            Swal.fire({
              icon: "error",
              title: lang["error"],
              text: `ERP phản hồi: ${o_message}`,
            });
          } else {
            Swal.fire({
              icon: "success",
              title: "Thành công",
              text: "Hủy phiếu thành công!",
            });
          }
        })
        .finally(() => {
          setLoading(false);
        });
    } catch (e) {
      Swal.fire({
        icon: "error",
        title: lang["error"],
        text: e,
      });
    }
  };
  return (
    <div>
      <FontAwesomeIcon
        icon={icons[icon]?.icon}
        title={item?.title ? item?.title : lang["redirect_button"]}
        onClick={handleModalShow}
      />
      <div>
        <Modal
          show={showModal}
          onHide={handleModalClose}
          dialogClassName="modal-80w"
        >
          <Modal.Header>
            <Modal.Title className="w-100">
              {/* Chứng từ KCS */}
              <div
                className="text-center fw-bold"
                style={{
                  textTransform: "uppercase",
                  fontWeight: "bold",
                }}
              >
                {item?.title ? item?.title : lang["redirect_button"]}
              </div>
            </Modal.Title>
          </Modal.Header>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Modal.Body>
              <div className="container-fluid">
                <div className="row form-row">
                  <div className="row col-sm-12 mb-2">
                    <div className="col-sm-5">Thành Phẩm</div>
                    <div className="col-sm-2">Số LOT</div>
                    <div className="col-sm-3">Kho Con</div>
                    {/* <div className="col-sm-2">Kho Đơn Vị</div> */}
                    {/* <div className="col-sm-2">Mã Vị Trí</div> */}
                    <div className="col-sm-2">Số Lượng (Tấn)</div>
                    {/* <div className="col-sm-1">Thao Tác</div> */}
                  </div>
                  {fields.map((item, index) => {
                    const kho = [item.khocon, item.tenkho]
                      .filter(Boolean)
                      .join("_");

                    console.log("khokho", kho);
                    return (
                      <div className="row col-sm-12 mb-2" key={item.id}>
                        <div className="col-sm-5">
                          <Controller
                            control={control}
                            name={`dataLogsPXk.${index}.masanpham`}
                            render={({ field }) => (
                              <Select
                                {...field}
                                isDisabled
                                value={{
                                  label: `${item?.masanpham}${
                                    item?.tensanpham
                                      ? ` | ` + item?.tensanpham
                                      : ""
                                  }`,
                                  value: item?.masanpham,
                                }}
                                placeholder={lang["select value"]}
                                noOptionsMessage={() => (
                                  <>{lang["not found data"]}</>
                                )}
                              />
                            )}
                          />
                        </div>

                        <div className="col-sm-2">
                          <Controller
                            control={control}
                            name={`dataLogsPXk.${index}.solot`}
                            render={({ field }) => (
                              <Select
                                {...field}
                                isDisabled
                                value={{
                                  label: item?.solot,
                                  value: item?.solot,
                                }}
                                placeholder={lang["select value"]}
                                noOptionsMessage={() => (
                                  <>{lang["not found data"]}</>
                                )}
                              />
                            )}
                          />
                        </div>

                        <div className="col-sm-3">
                          <input
                            type="text"
                            className="form-control"
                            disabled
                            // {...register(`dataLogsPXk.${index}.khocon`)}
                            defaultValue={kho}
                          />
                        </div>

                        {/* <div className="col-sm-2">
                          <Controller
                            control={control}
                            name={`dataLogsPXk.${index}.khocon`}
                            render={({ field }) => (
                              <Select
                                {...field}
                                //   options={dataKhoDonVi}
                                placeholder={lang["select value"]}
                                noOptionsMessage={() => (
                                  <>{lang["not found data"]}</>
                                )}
                                // value={{
                                //   label: item?.khocon,
                                //   value: item?.khocon,
                                // }}
                              />
                            )}
                          />
                        </div> */}

                        {/* <div className="col-sm-2">
                          <Controller
                            control={control}
                            name={`dataLogsPXk.${index}.vitritrongkho`}
                            render={({ field }) => (
                              <Select
                                {...field}
                                //   options={dataViTri}
                                placeholder={lang["select value"]}
                                noOptionsMessage={() => (
                                  <>{lang["not found data"]}</>
                                )}
                                value={{
                                  label: item?.vitritrongkho,
                                  value: item?.vitritrongkho,
                                }}
                              />
                            )}
                          />
                        </div> */}

                        <div className="col-sm-2">
                          <input
                            type="number"
                            min={0}
                            step="any"
                            className="form-control"
                            {...register(
                              `dataLogsPXk.${index}.soluongtanxuatthucte`,
                              { valueAsNumber: true }
                            )}
                            disabled={true}
                            // defaultValue={item?.soluongtanxuatthucte}
                          />
                        </div>

                        {/* <div className="col-sm-1">
                          <button
                            type="button"
                            className="btn btn-danger m-0"
                            onClick={() => remove(index)}
                          >
                            Xóa
                          </button>
                        </div> */}
                      </div>
                    );
                  })}

                  {/* <div className="col-sm-12 mt-1">
                    <label className="fw-bold">
                      Tổng Số Lượng Xuất Thực Tế:
                    </label>
                  </div>
                  <div className="col-sm-12 mt-4">
                    <label className="fw-bold">Ghi chú</label>
                    <textarea className="form-control" rows={5}></textarea>
                  </div> */}
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer
              style={{
                justifyContent: "center",
              }}
            >
              {/* <Button variant="primary" onClick={handleModalClose}>
                Cập Nhật
              </Button> */}
              <Button
                variant="danger"
                type="submit"
                // onClick={() => {
                //   Swal.fire({
                //     title: "Xác nhận",
                //     text: "Bạn có chắc muốn hủy phiếu không?",
                //     icon: "warning",
                //     showCancelButton: true,
                //     confirmButtonText: "Đồng ý",
                //     cancelButtonText: "Hủy",
                //   }).then((result) => {
                //     if (result.isConfirmed) {
                //       handleCancelVote();
                //     }
                //   });
                // }}
              >
                Hủy Phiếu
              </Button>
              <Button
                variant="secondary"
                onClick={handleModalClose}
                className="ml-2"
              >
                Đóng
              </Button>
            </Modal.Footer>
          </form>
        </Modal>
      </div>
    </div>
  );
}
